var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ReDocWrapper',{attrs:{"specOrSpecUrl":`${_vm.origin}/${_vm.$route.params.domain}/${_vm.$route.params.module}`}})
}
var staticRenderFns = []

export { render, staticRenderFns }